var date = {};
module["exports"] = date;
date.month = require("./month");
date.weekday = require("./weekday");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/ru/date/index.js
 ** module id = 928
 ** module chunks = 0
 **/